import {ADD_ALL_PRODUCTS, CLEAR_PRODUCTS, SET_HARDWARE_ID, SET_USERNAME} from "../actions/filters";
import {productList, saveProducts} from "../service/localStorageService";
import {defaultFilters} from "../store/configureStore";
import {clientInfo} from "../service/ClientInfo";
import {PREV_CONTENT, NEXT_CONTENT} from "../components/Pagination";

function getProducts(filter){
    return filter.products;
}

function getPaginationKey(data, pagEventType) {
    if (typeof data.dateUsers !== 'undefined' && data.dateUsers.length != 0){
        if( pagEventType == NEXT_CONTENT)
            return data.dateUsers[data.dateUsers.length - 1][data.dateUsers[data.dateUsers.length - 1].length-1].key;
        else if (pagEventType == PREV_CONTENT)
            return data.dateUsers[0][0].key;
    }
    return '';
}

function getSessionNumberForPagination(data, pagEventType) {
    if (typeof data.dateUsers !== 'undefined' && data.dateUsers.length != 0) {
        if (pagEventType == NEXT_CONTENT)
            return data.dateUsers[data.dateUsers.length - 1].length;
        else if (pagEventType == PREV_CONTENT)
            return data.dateUsers[0].length;
    }
    return 0;
}

function getStartDate(data, pagEventType, filter) {
    if (typeof data.dateUsers !== 'undefined' && data.dateUsers.length != 0 && pagEventType == NEXT_CONTENT) {
        return data.dateUsers[data.dateUsers.length - 1][0].date;
    }
    return filter.startDate;
}

function getEndDate(data, pagEventType, filter) {
    if (typeof data.dateUsers !== 'undefined' && data.dateUsers.length != 0 && pagEventType == PREV_CONTENT) {
        return data.dateUsers[0][0].date;
    }
    return filter.endDate;
}

export const getMessage=(filter, data, pagEventType, user, _id, count)=>{
  switch (filter.path)  {
      case DATE_USERS:
      case USAGE:
      case METRIKA:
      case EXCEPTIONS:
          return {
              from: getStartDate(data, pagEventType, filter),
              to: getEndDate(data, pagEventType, filter),
              limit:filter.limit,
              products: getProducts(filter),
              username : filter.username,
              hardwareId : filter.hardwareId,
              paginationEventType: pagEventType,
              paginationKey: getPaginationKey(data, pagEventType),
              sessionNumberForPagination: getSessionNumberForPagination(data, pagEventType),
              _id: _id,
              count: count
          };
      case KEY:
      case RAW:
          return {
            key:filter.key
          };
      case LOGIN:
          return {
              username:user.username,
              password:user.password,
              browser: clientInfo()
          };
  }
};
export const getAuth=(filter, user)=>{
    switch (filter.path)  {
        default:
        case DATE_USERS:
        case KEY:
        case RAW:
        case METRIKA:
            return  user.token;

        case LOGIN:
            return undefined
    }
};


export const DATE_USERS='/date/users';
export const KEY='/key';
export const RAW='/raw';
export const METRIKA='/metrika';
export const USAGE='/usage';
export const LOGIN = '/pub/admin/login';
export const EXCEPTIONS = '/exceptions';


export default (state=defaultFilters, action)=>{
  //  console.log(state);
  let products;
  switch (action.type){
      case 'SET_START_DATE':
          return {
              ...state,
              startDate: action.startDate,
              path:DATE_USERS
          };
      case 'SET_END_DATE':
          return {
              ...state,
              endDate: action.endDate,
              path:DATE_USERS
          };
      case 'SET_PATH':
          return {
              ...state,
              path: action.path
          };
      case 'SET_AUTH_URL':
          return {
              ...state,
              authUrl: action.authUrl
          };
      case 'SET_STAT_SERVER_URL':
            return {
                ...state,
                statServerUrl: action.statServerUrl
            };
      case 'SET_PORT':
          return {
              ...state,
              port: action.port
          };
      case 'ADD_PRODUCT':
          const ind=state.products.indexOf(action.product);
          products = [...state.products, action.product];
          saveProducts(products);
          return ind!==-1 ? state:{
              ...state,
              products
          };
      case 'REMOVE_PRODUCT':
          const index=state.products.indexOf(action.product);
          products=[
              ...state.products.slice(0, index),
              ...state.products.slice(index + 1)];
          saveProducts(products);
          return index===-1 ? state:
              {...state, products};
      case ADD_ALL_PRODUCTS:
          saveProducts(productList);
          return {...state,products : [...productList] };
      case CLEAR_PRODUCTS:
          saveProducts([]);
          return {...state,products: []};
      case SET_USERNAME:
          return {...state,username : action.username}
      case SET_HARDWARE_ID:
          return {...state,hardwareId : action.hardwareId}
      case 'SET_KEY':
          return {
              ...state,
              key: action.key,
              path:KEY
          };
      case 'SET_LIMIT':
          return {
              ...state,
              limit: action.limit
          };
      case 'SET_CUR_PAGE':
          var stateCurPages = state.curPages;
          stateCurPages[action.key] = action.value;
          return {
              ...state,
              curPages: stateCurPages
          };
      case 'SET_CLEAR_RESULTS':
         var stateClearResults = state.clearResults;
         stateClearResults[action.key] = action.value;
         return {
              ...state,
              clearResults: stateClearResults
          };
      default:
          return state;
  }
};

